import React, { Component } from 'react'
import CookieConsent from 'react-cookie-consent'
import { Dialog, FlatButton, Toggle } from '@material-ui/core'
import i18n from 'simple-react-i18n'
import {
	AQUADB_COOKIE
} from '../../utils/cookie/constants/CookieConstants'
import { checkCookies, createCookie, initCookieOption } from '../../utils/cookie/CookieUtils'

class CookiePanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			open: false,
			statisticsCookies: true,
			advertisingCookies: true
		}
	}

	handleModal = (value = false) => {
		this.setState({ open: value })
	}

	changeState = (cookieId) => {
		const actualState = Object.assign({}, this.state)
		actualState[cookieId] = !actualState[cookieId]
		this.setState(actualState)
	}

	validateCookies = () => {
		createCookie(AQUADB_COOKIE, {
			advertisingCookies: this.state.advertisingCookies,
			statisticsCookies: this.state.statisticsCookies
		})
		this.setState({ open: false })
	}

	getPanelAcceptCookie = (title, text, cookieStateName) => {
		return (
			<div className='row no-margin'>
				<div className='col s12 '>
					<div className='row no-margin'>
						<div className='col s11 no-padding'>
							<span className='bold' style={ { fontSize: '20px', fontWeight: 'bolder' } }>{ title }</span>
						</div>
						<div className='col s1 no-padding'>
							<Toggle
								defaultToggled={ this.state[cookieStateName] }
								onToggle={ () => this.changeState(cookieStateName) }
							/>
						</div>
					</div>
				</div>
				<div className='col s12 '>
					<span>{ text }</span>
				</div>
			</div>
		)
	}

	render() {
		initCookieOption()
		if (checkCookies()) {
			const actions = [
				<FlatButton
					label={ i18n.cancel }
					primary={ true }
					onClick={ () => this.handleModal() }
				/>,
				<FlatButton
					label={ i18n.validate }
					primary={ true }
					onClick={ () => this.validateCookies() }
				/>
			]
			return (
				<div>
					<CookieConsent
						debug
						location='bottom'
						buttonText={ i18n.accepted }
						cookieName={ AQUADB_COOKIE }
						containerClasses={ 'no-margin no-padding' }
						style={ { background: '#2B373B' } }
						buttonStyle={ {
							height: '36px',
							borderRadius: '2px',
							transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
							top: '0px'
						} }
						onAccept={ () => this.validateCookies() }
					>
						{ i18n.cookie.description }<br/>
						<a onClick={ () => this.handleModal(true) }>{ i18n.cookie.more }</a>
					</CookieConsent>
					<Dialog
						actions={ actions }
						modal={ true }
						open={ this.state.open }
					>
						<div className='row'>
							<div className='col s12'>
								<div className='row center-align'>
									<h5>{ i18n.cookie.moreTitle }</h5>
								</div>
								<div className='row'>
									<div className='col s6'>
										{ this.getPanelAcceptCookie(i18n.cookie.communication, i18n.cookie.communicationComment, 'advertisingCookies') }
									</div>
									<div className='col s6'>
										{ this.getPanelAcceptCookie(i18n.cookie.statistics, i18n.cookie.statisticsComment, 'statisticsCookies') }
									</div>
								</div>
							</div>
						</div>
					</Dialog>
				</div>
			)
		}
		return null
	}
}

export default CookiePanel



// WEBPACK FOOTER //
// ./src/components/cookie/CookiePanel.js